import React from "react";

export const Prestations = (props) => {
  return (
    <div id="prestations">
      <div style={{ textAlign: "center" }}>
        <a
          href="https://www.planity.com/beauty-salon-06000-nice"
          target="_blank"
          className="btn btn-custom btn-lg page-scroll"
          style={{ marginTop: "150px" }}
        >
          Réservez un RDV
        </a>
      </div>

      {props.data
        ? props.data.map((p, i) => (
            <div className="container" key={i}>
              <div className="section-title text-center">
                <h2>{p.name}</h2>
              </div>
              {p.name === "Épilation" ? (
                <div className="row">
                  {p.Details
                    ? p.Details.map((d, j) => (
                        <div key={`${d.section}-${j}`} className="col-md-6">
                          <h3 className="text-center">{d.section}</h3>

                          {d.Details
                            ? d.Details.map((q, j) => (
                                <div
                                  key={`${q.name}-${j}`}
                                  className="col-md-12"
                                >
                                  <div className="prestation">
                                    <div className="prestation-meta">
                                      <div className="prestation-image">
                                        <img
                                          src={`${process.env.PUBLIC_URL}/icons/cherry-blossom.png`}
                                          alt="Service Icon"
                                        />
                                      </div>
                                      {q.name} - <strong>{q.price}</strong>
                                    </div>
                                  </div>
                                </div>
                              ))
                            : "loading"}
                        </div>
                      ))
                    : "loading"}
                </div>
              ) : (
                <div className="row">
                  {p.Details
                    ? p.Details.map((d, j) => (
                        <div key={`${d.name}-${j}`} className="col-md-6">
                          <div className="prestation">
                            <div className="prestation-meta">
                              <div className="prestation-image">
                                <img
                                  src={`${process.env.PUBLIC_URL}/icons/cherry-blossom.png`}
                                  alt="Service Icon"
                                />
                              </div>
                              {d.name} - <strong>{d.price}</strong>
                            </div>
                          </div>
                        </div>
                      ))
                    : "loading"}
                </div>
              )}
            </div>
          ))
        : "loading"}
    </div>
  );
};
